import { getContentFullUrl } from "@/lib/contentUtils";
import { DSContentType, DSPlayerOBj, PlayerComputedContentOrContentGroup, PlaylistItemDTO } from "./types";
import _ from "lodash";

const DEFAULT_DURATION = 5;

const dsTypeToPlaylistType = (dsType: DSContentType): PlaylistItemDTO["type"] | undefined => {
  if (!dsType) return undefined;
  if (dsType.startsWith("image/")) {
    return "Image";
  } else if (dsType.startsWith("video/")) {
    return "Video";
  } else if (dsType.startsWith("audio/")) {
    return "Audio";
  } else if (dsType === "link") {
    return "Link";
  } else if (dsType === "split") {
    return "Split";
  } else if (dsType === "application/pdf") {
    return "Doc";
  }
};

export const generatePlaylist = (
  contentOrContentGroup: PlayerComputedContentOrContentGroup[],
  fallBackContent: DSPlayerOBj<Date>["playerDefaultContent"] | undefined,
  { width: playerScreenSizeWidth, height: playerScreenSizeHeight }: { width: number; height: number }
): PlaylistItemDTO[] => {
  const playList: PlaylistItemDTO[] = [];

  for (const item of contentOrContentGroup || []) {
    if ("contentId" in item) {
      const type = dsTypeToPlaylistType(item.contentType);
      if (type) {
        playList.push({
          id: item.contentId,
          intId: item.contentintId,
          type,
          src:
            // Put the fallback content src if the member is an audio
            type === "Audio"
              ? getContentFullUrl(fallBackContent?.contentStorageName || "")
              : getContentFullUrl(item?.contentStorageName || ""),
          audioSrc: type === "Audio" ? getContentFullUrl(item?.contentStorageName || "") : undefined,
          duration: item.contentDuration || DEFAULT_DURATION,
          isActive: true,
          splitViewportSize: `${playerScreenSizeWidth}x${playerScreenSizeHeight}`,
          splitLayoutConfig: item?.layoutConfig,
          linkSrc: item?.contentLink,
        });
      }
    } else if ("contentGroupId" in item) {
      const contentGroup = item;
      let members = contentGroup.contentDetials.sort((a, b) => a.order - b.order);

      if (contentGroup.isShuffle) {
        members = _.shuffle(members);
      }

      for (const member of members) {
        const type = dsTypeToPlaylistType(member.contentType);
        if (type) {
          playList.push({
            id: member.contentId,
            intId: member.contentintId,
            type,
            src:
              // Put the fallback content src if the member is an audio
              type === "Audio"
                ? getContentFullUrl(fallBackContent?.contentStorageName || "")
                : getContentFullUrl(member?.contentStorageName || ""),
            audioSrc: type === "Audio" ? getContentFullUrl(member?.contentStorageName || "") : undefined,
            duration: member.contentDuration || DEFAULT_DURATION,
            isActive: member.isActive,
            splitViewportSize: `${playerScreenSizeWidth}x${playerScreenSizeHeight}`,
            splitLayoutConfig: member.layoutConfig,
            linkSrc: member.contentLink,
          });
        }
      }
    }
  }

  return _.uniqBy(playList, "id");
};
